import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import Typography from '../../../Typography'
import Icon from '../../../Icon';


const styles = theme => ({
  root_list_item: {
    cursor: "pointer",
    padding: theme.margins.xs,
    '&:hover': {
      background: theme.palette.lightGrey,
    },
  },
  selected: {
    fontWeight: theme.fontWeight.bold,
  },
  icon_class_container: {
    marginTop: -2
  },
})

 const ListItemComponent = ({
    classes,
    item,
    key,
    selected_value,
    handle_select,
    icon_type,
    search_value
  }) => {

    const splitted_item = React.useMemo(() => {
      if (!search_value) { return [item.name]; }
      return item.name
            .replace(RegExp(search_value,"gi"), (...args) => {
              const o = args[0], i = args[args.length - 2];
              return i === 0
                ? `${o}__`
                : i === item.name.length - 1
                ? `__${o}`
                : `__${o}__`;
            })
            .split('__');

    },[item.name, search_value]);

    return (
      <MenuItem
          selected = {selected_value === item.id}
          onClick = { e => {
            handle_select(e, item) }
          }
          classes = {{
            root: classes.root_list_item,
            selected:  classes.selected
          }}
          value=""
        >
         {
           Boolean(icon_type)
           ? <ListItemIcon className = {classes.icon_class_container}>
               <Icon type = {icon_type}/>
             </ListItemIcon>
           : null
         }
           <Typography
              type = {"body1"}
              className = {classes.typography}

            >
             {
              splitted_item.map((o,idx) => {
                const typed = Boolean(search_value) && Boolean(o) && RegExp(`${search_value}`,"gi").test(o);
                return typed
                ? <b key = {`simple-list-${o}-${idx}`}>{o}</b>
                : <React.Fragment key = {`simple-list-${o}-${idx}`}>{o}</React.Fragment>
              }
            )
          }
          </Typography>
       </MenuItem>
    )
  };

  ListItemComponent.propTypes = {
    classes: PropTypes.object,
    item: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }),
    key: PropTypes.string,
    selected_value: PropTypes.string,
    handle_select: PropTypes.func,
    icon_type: PropTypes.string,
    search_value: PropTypes.string
  }

  export default React.memo(withStyles(styles)(ListItemComponent));
